import React from 'react';
import { Card, CardContent, Box, Divider, Skeleton } from '@mui/material';

const WazarenCardSkeleton = () => {

    return (
        <Card>
            <CardContent>
                {/* Card content info */}
                <Box ml={2} >
                    <Skeleton variant='rectangle' width="200px" height="20px" />
                    <Box sx={{ m: 1 }} />
                    <Skeleton />
                    {/* <Box sx={{ m: 1 }} />
                    <Skeleton /> */}
                    <Box sx={{ m: 1 }} />
                    <Box>
                    <Skeleton />
                    </Box>
                    <Box sx={{ m: 1 }} />
                    <Divider />
                    <Box sx={{ m: 1 }} />
                    <Box display="flex" alignItems="center">
                        <Skeleton variant='rectangle' width="100px" />
                    </Box>
                </Box>
            </CardContent>
        </Card>
    );
};

export default WazarenCardSkeleton;